export default __webpack_public_path__ + "img/dfvbXKxd.a7b3dc10.svg";